import { resources } from "@constants/hardcoded-strings";
import {
    GeneralValidationErrors,
} from "@idw-types/common/validation/verification-service-details-validation-errors/verification-service-details-validation-errors";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { getGeneralBasicInfoValidationErrors } from "./general-basic-info-validation-util";
import { getGeneralAdvancedValidationErrors } from "./general-advanced-validation-util";

export const getGeneralValidationErrors = (
    rpServiceConfiguration: FormattedRpServiceConfiguration,
    showPinCodeSection: boolean
): GeneralValidationErrors => {

    const basicInfoValidationErrors = getGeneralBasicInfoValidationErrors(rpServiceConfiguration);
    const advancedValidationErrors = getGeneralAdvancedValidationErrors(rpServiceConfiguration.properties, rpServiceConfiguration.appliedProfiles, rpServiceConfiguration.attributes, showPinCodeSection);
    const count = basicInfoValidationErrors.count + advancedValidationErrors.count;

    return {
        basicInfo: basicInfoValidationErrors,
        advanced: advancedValidationErrors,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.verificationServiceDetails.tabs.general.tabName} errorCount={count} />
    };
};
